module.exports = __webpack_public_path__ + "img/icon-contra-entrega.f0f9eed0.svg";